import * as React from 'react'

import asyncAction from 'modules/core/lib/asyncAction'

import EditCategoryModal from 'modules/surveys/components/Questions/Categories/EditCategoryModal'
import { useQuestionCategory } from 'modules/surveys/hooks/useQuestionCategory'

interface Props {
  formId: number
  onClose: () => void
  questionGroupConfigId: number
  questionCategoryId: number
}

// TODO: review this interface used in `updateQuestionCategory`
// interface DataObject {
//   name: string;
//   question_category_id: number;
// }
export default function EditCategoryModalContainer({ formId, questionCategoryId, onClose }: Props) {
  const { questionCategory } = useQuestionCategory(questionCategoryId, formId)

  const updateQuestionCategory = async (data: Record<string, unknown>) => {
    if (!questionCategory) return

    data['surveys_form_id'] = formId
    const { value } = await asyncAction(() => questionCategory.save(data))

    return value
  }

  if (!questionCategory) return null

  return (
    <EditCategoryModal
      category={questionCategory}
      onClose={onClose}
      onSubmit={updateQuestionCategory}
    />
  )
}
